import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_IMPORTED_RECORD } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute(
  '/_authenticated/expenses_import/expense/import/record/edit/$id'
)({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_IMPORTED_RECORD, ['update'], '/unauthorized', context);
    return { ...context };
  },
  // The edit modal is opened by the parent layout (ImportRefuelings) based on the URL.
  component: () => null,
});
